<div #pdfContent *ngIf="report" class="print-container content">

    <div class="padding-left-box">
        <div class="shadow-header font-header">
            <span>{{ report.delegate.full_name }} <span style="font-weight: normal;">- {{ "__REVIEW_PDR_REPORT__" | translate }}</span></span>
            <div style="border-bottom: 2px solid #8dc63f; width: 70%;"></div>
        </div>

        <div class="input-group" style="width: 20rem; font-size: 1.56rem; text-align: center; font-weight: normal; padding: 0 1rem .5rem; border-bottom: 2px solid #8dc63f">
            {{report.period.value}}
        </div>

        <div *ngIf="level === 'learner'" class="font-smaller">{{ "__REVIEW_LEARNER_HINT__" | translate }}</div>
        <div *ngIf="level === 'manager'" class="font-smaller">{{ "__REVIEW_MANAGER_HINT__" | translate }}</div>
    </div>

    <app-dropdown-box
        [opened]="true"
        [title]="'__REVIEW_REPORT_FORM_SELF_TITLE__' | translate : {name : (level === 'manager' ? report.delegate.full_name : ('__REVIEW_REPORT_FORM_SELF_YOU__' | translate))}"
        [date]="selfUpdatedAt">
    </app-dropdown-box>

    <div class="dropdown-content">
        <div class="font-larger">{{ "__REVIEW_QUESTION_HINT__" | translate }}</div>
        <app-questionnaire-text
            *ngFor="let answer of report.answers_self.value"
            [title]="answer.question.title"
            [hint]="answer.question.hint"
            [answer]="answer.answer.value"
            class="line-top"
        ></app-questionnaire-text>
    </div>
    <app-dropdown-box
        [opened]="true"
        [title]="'__REVIEW_REPORT_FORM_SELF_TITLE__' | translate : {name : (level === 'manager' ? '__REVIEW_REPORT_FORM_SELF_YOU__' : '__REVIEW_REPORT_FORM_SELF_YOUR_MANAGER__') | translate}"
        [date]="managerUpdatedAt">
    </app-dropdown-box>
    <div class="dropdown-content">
        <div class="font-larger" style="display: flex; flex-direction: column; gap: 1.5rem;">
          <span>{{ "__REVIEW_FORM_HINT_1__" | translate }}</span>
          <span>{{ "__REVIEW_FORM_HINT_2__" | translate }}</span>
        </div>
        <div class="line-top" style="padding-top: .5rem;"></div>
        <app-questionnaire-text
            *ngFor="let answer of report.answers_manager.value"
            [title]="answer.question.title"
            [hint]="answer.question.hint"
            [answer]="answer.answer.value"
        ></app-questionnaire-text>
    </div>

    <div class="page-break"></div>

    <app-dropdown-box
        [opened]="true"
        [title]="('__REVIEW_REPORT_FORM_GOALS_TITLE__' | translate) + (level === 'manager' ? ' (' + report.delegate.full_name + ')' : '')"
        [date]="recordsUpdatedAt"></app-dropdown-box>
    <div class="dropdown-content" style="gap: 1rem;">
        <div class="font-larger">{{ "__REVIEW_BUILD_PDR_HINT__" | translate }} </div>
        <app-dropdown-box [opened]="true" [hasDate]="false" [title]="'__REVIEW_REPORT_FORM_GOALS_FEEDBACK_TITLE__'" [color]="'green'"></app-dropdown-box>
        <div class="bg-content feedback show">
            <div class="table-header font-larger">
                <div>{{ "__REVIEW_REPORT_FORM_GOALS_FORM_NAME__" | translate }}</div>
                <div class="ion-text-center">{{ "__REVIEW_REPORT_FORM_GOALS_FORM_DATE__" | translate }}</div>
                <div></div>
            </div>
            <div class="objective-wrapper">
                <app-feedback [feedback]="feedback" [show]="true" *ngFor="let feedback of report.feedbacks; let i = index;">
                    <div class="dropdown-content" style="padding: 0; width: 100%;">
                        <app-questionnaire-text
                            *ngFor="let answer of feedback.feedback_answers"
                            [title]="answer.question.title"
                            [hint]="answer.question.hint"
                            [answer]="answer.answer"
                            class="smaller smaller-fonts">
                        </app-questionnaire-text>
                    </div>
                </app-feedback>
            </div>
        </div>

        <ng-container *ngFor="let objective of report.goals.value; let i = index;">

            <div class="page-break"></div>

            <app-dropdown-box [opened]="true" style="position: relative;" [hasDate]="false" [title]="'__REVIEW_REPORT_GOALS_AND_OBJECTIVES_TITLE__' | translate"
                              [color]="'green'"> </app-dropdown-box>

            <div [ngClass]="{'show': true, 'objective-filter': level === 'learner'}"
                 class="bg-content">
                <div class="table-header font-larger">
                    <div>{{ "__REVIEW_REPORT_GOALS_AND_OBJECTIVES_FORM_TITLE__" | translate }}</div>
                    <div></div>
                    <div class="ion-text-center">{{ "__REVIEW_REPORT_LIST_HEADER_CREATED__" | translate }}</div>
                    <div class="ion-text-center">{{ "__REVIEW_REPORT_GOALS_AND_OBJECTIVES_FORM_DURATION__" | translate }}</div>
                    <div class="ion-text-center">{{ "__REVIEW_REPORT_LIST_HEADER_STATUS__" | translate }}</div>
                </div>

                <div class="objective-wrapper">
                    <app-objective
                        [show]="true"
                        [objective]="objective">
                        <div class="dropdown-content" style="padding: 0; width: 100%;">
                            <app-questionnaire-text
                                *ngFor="let answer of objective.goal_answers.value"
                                [title]="answer.question.title"
                                [hint]="answer.question.hint"
                                [answer]="answer.answer.value"
                                class="smaller smaller-fonts">
                            </app-questionnaire-text>
                        </div>
                    </app-objective>
                </div>
            </div>
        </ng-container>

        <div class="page-break"></div>

        <app-dropdown-box [opened]="true" [hasDate]="false" [title]="'__REVIEW_REPORT_GOALS_SIX_MONTH_NOTES__' | translate" [color]="'green'"></app-dropdown-box>
        <div class="dropdown-content" style="flex-direction: row; align-items: flex-end;">
            <app-questionnaire-text
                *ngFor="let answer of report.answers_note.value; let i = index;"
                [title]="i > 0 ? answer.question.title : null"
                [hint]="i > 0 ? answer.question.hint : null"
                [answer]="answer.answer.value"
                style="width: 100%;"
            ></app-questionnaire-text>
            <img *ngIf="false && level === 'learner'" src="assets/img/trash-icon.svg" alt="">
        </div>
    </div>
</div>

